<template>
  <v-container>
    <taxStreetsUI />
  </v-container>
</template>

<script>
import taxStreetsUI from '../../components/shared/taxStreets/taxStreetsList.vue';

export default {
  name: 'taxStreets',
  components: {
    taxStreetsUI,
  },
};
</script>
